import { createApi } from '@reduxjs/toolkit/query/react';

import { API_BASE_URL } from '@/config';
import { nonAbortingSignalBaseQuery } from '@/store/services/baseQuery';

export const LEADS_LIST_TAG = { id: 'LIST', type: 'Leads' };

export const buildGetLeadsUrl = ({ converted } = {}) => {
    const params = converted === undefined ? '' : `?converted=${converted}`;
    return `${API_BASE_URL}/admin/leads${params}`;
};

const leadsApi = createApi({
    baseQuery: nonAbortingSignalBaseQuery,
    endpoints: (builder) => ({
        createLead: builder.mutation({
            query: (body) => ({
                body,
                method: 'POST',
                url: `${API_BASE_URL}/leads/`,
            }),
        }),
        getLeads: builder.query({
            providesTags: [LEADS_LIST_TAG],
            query: buildGetLeadsUrl,
        }),
        promoteLead: builder.mutation({
            invalidatesTags: [LEADS_LIST_TAG],
            query: (leadId) => ({
                method: 'POST',
                url: `${API_BASE_URL}/admin/leads/${leadId}/promote`,
            }),
        }),
        updateLead: builder.mutation({
            invalidatesTags: [LEADS_LIST_TAG],
            query: ({ body, leadId }) => ({
                body,
                method: 'PATCH',
                url: `${API_BASE_URL}/admin/leads/${leadId}`,
            }),
        }),
    }),
    reducerPath: 'leadsApi',
    tagTypes: ['Leads'],
});

export const { useCreateLeadMutation, useGetLeadsQuery, usePromoteLeadMutation, useUpdateLeadMutation } = leadsApi;
export default leadsApi;
